import React from "react";
import { Button } from "design-system";

import Page from "./Page";
import {
  createMessage,
  PAGE_SERVER_TIMEOUT_DESCRIPTION,
  PAGE_SERVER_TIMEOUT_ERROR_CODE,
  PAGE_SERVER_TIMEOUT_TITLE,
} from "ee/constants/messages";
import GradientButton from "components/GradientButton";

function ServerTimeout() {
  return (
    <Page
      cta={
        // <Button
        //   className="button-position"
        //   kind="primary"
        //   onClick={() => window.location.reload()}
        //   size="md"
        // >
        //   重试
        // </Button>
        <GradientButton
          onClick={() => window.location.reload()}
          size="middle"
        >
          重试
        </GradientButton>
      }
      description={createMessage(PAGE_SERVER_TIMEOUT_DESCRIPTION)}
      errorCode={createMessage(PAGE_SERVER_TIMEOUT_ERROR_CODE)}
      title={createMessage(PAGE_SERVER_TIMEOUT_TITLE)}
    />
  );
}

export default ServerTimeout;
